module.exports = __webpack_public_path__ + "static/media/Bella-Terra-Master-Deed.0792289d.pdf";